import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropsType from 'prop-types';

import { dateFormatter } from '#client/utils/chart';

import { COLOR_HISTORY_BALANCE } from '../constants/colors';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const showDate = dateFormatter(label, { month: 'short', day: 'numeric' });
    const amount = currencyFormatter.format(payload[0].value / 100);

    return (
      <Box
        bgcolor={COLOR_HISTORY_BALANCE.TOOLTIP_BACKGROUND}
        borderRadius="12px"
        px="12px"
        py="8px"
      >
        <Stack
          alignItems="center"
          direction="column"
          spacing="4px"
        >
          <Text
            color="white"
            size="xs"
          >{`${showDate}`}</Text>
          <Text
            color="white"
            size="xs"
            weight="medium"
          >
            {amount}
          </Text>
        </Stack>
      </Box>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  active: PropsType.bool,
  payload: PropsType.arrayOf(
    PropsType.shape({
      value: PropsType.number
    })
  ),
  label: PropsType.string
};

export default CustomTooltip;
